import * as React from 'react';
import { Wormhole } from '@workwave-tidal/core/hooks'
import type { PropsWithChildren } from 'react'
import { useWormholeId } from '../WormholeIdProvider.js'

export type ConversationSuggestionsProps = PropsWithChildren

export function ConversationSuggestions(props: ConversationSuggestionsProps) {
  const { children } = props

  const target = useWormholeId('editorSuggestions')

  return <Wormhole target={target}>{children}</Wormhole>
}
